import { useCallback, useMemo } from 'react';
import useApi from './useApi';
import { useAppSettings } from '../hooks/useAppSettings';
import { buildApiUrl } from '../utils/apiUtils';
import { mapProductFromApi } from '../factory/ProductFactory';

export default (productId: string | number) => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();

    const getProduct = useCallback(async () => {
        if (!productId) {
            console.error('[useGetProduct] Product ID is required');
            return;
        }

        try {
            const apiUrl = appSettings?.api;
            if (!apiUrl) {
                throw new Error('API URL not configured in app settings');
            }
            console.log(`[useGetProduct] Fetching product ID: ${productId}`);
            await getApiData({
                endpoint: buildApiUrl(apiUrl, `/GetProduct?id=${productId}`),
            });
        } catch (error) {
            console.error('[useGetProduct] Failed to fetch product:', error);
        }
    }, [getApiData, productId, appSettings]);

    // Map the API response using ProductFactory
    const product = useMemo(() => {
        if (!state.result) return null;
        try {
            return mapProductFromApi(state.result);
        } catch (error) {
            console.error('[useGetProduct] Failed to map product data:', error);
            return null;
        }
    }, [state.result]);

    return {
        state,
        getProduct,
        isLoading: state.isLoading,
        error: state.error,
        product,
    };
};
